module.exports = __webpack_public_path__ + "media/images/sp/visit_reserve/bg-header-9ac86c5e2f0a7229cf82ff2e903bd2c8.png";